/* eslint-disable no-undef */
"use strict";


// Call the function to set up the hover effect
$(document).ready(function () {
    checkPdpSwatchImages();
});

function checkPdpSwatchImages() {
    // Select all PDP tiles that contain swatches
    const pdpTiles = document.querySelectorAll(".pdp-attributes");

    pdpTiles.forEach(tile => {
        // Select all swatches within the current tile
        const swatches = tile.querySelectorAll(".color-attribute");

        swatches.forEach(swatch => {
            const img = swatch.querySelector("img");
            if (img) {
                // Add an event listener for the error event
                img.addEventListener("error", function () {
                    checkImageStatus(img.src, function (is404) {
                        if (is404) {
                            swatch.classList.add("d-none");
                        }
                    });
                });

                // Check if the image is already broken after it has loaded
                img.addEventListener("load", function () {
                    if (!img.complete || img.naturalWidth === 0) {
                        checkImageStatus(img.src, function (is404) {
                            if (is404) {
                                swatch.classList.add("d-none");
                            }
                        });
                    }
                });

                // If the image is already loaded and broken, hide the swatch
                if (img.complete && img.naturalWidth === 0) {
                    checkImageStatus(img.src, function (is404) {
                        if (is404) {
                            swatch.classList.add("d-none");
                        }
                    });
                }
            } else {
                swatch.classList.add("d-none");
            }
        });
    });
}

function checkImageStatus(url, callback) {
    fetch(url)
        .then(response => {
            callback(response.status === 404);
        })
        .catch(() => {
            callback(true);
        });
}
